import _ from 'lodash'
import { isContains } from '@/components/utils/isContains'

export default {
    name: 'TreeItem',
    data () {
        return {
            open: false,

        }
    },
    props: {
        model: {
            type: Object
        },
        bus: {
            type: Object,
            required: true,
        },
        root: {
            type: [Number, String],
            default: null,
        },
        value: {
            type: [Number, String],
            default: null,
        },
        search: {
            type: String,
            default: '',
        },
        level: {
            type: Number,
            default: 1,
        },
        /**
         * Если в model имеется поле isHighRoot
         * в значении true, то действие этого свойства
         * отменяется
         */
        selectOnName: {
            type: Boolean,
            default: false
        },
        openDefault: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.updateTree()
    },
    computed: {
        hasChildren() {
            return this.model.children && this.model.children.length
        },
        active() {
            return this.model.root == this.root && this.model.value == this.value
        },
        found() {
            return this.isContains(this.search, this.model.name)
        }
    },
    watch: {
        search() {
            this.updateTree()
        },
        value() {
            this.updateTree()
        }
    },
    methods: {
        isContains,

        toggle() {
            this.open = ! this.open
            this.$nextTick(() => {
              this.bus.$emit('update')
            })
        },
        emitSelect() {
            this.bus.$emit('select', {
                ...this.model
            })
        },
        select(model) {
            if (this.selectOnName && !model.isHighRoot || !this.model.children || this.model.children.length === 0) {
                this.emitSelect()
                return
            }
            this.toggle()
        },
        onIconClick(event, model) {
            if (this.selectOnName && !model.isHighRoot) {
                event.stopPropagation()
                this.toggle()
            }
        },
        findByCriteria(model, criteria) {
            let i,
                currentChild,
                result

            if (criteria(model)) {
                return model
            } else {
                if (model.children)
                    for (i = 0; i < model.children.length; i++) {
                        currentChild = model.children[i]

                        result = this.findByCriteria(currentChild, criteria)

                        if (result !== false) {
                            return result
                        }
                    }

                return false;
            }
        },
        updateTree() {
            if (this.openDefault) {
                this.open = true
                return
            }
            if (this.search && this.search.length) {
                this.open = !! this.findByCriteria(this.model, model => {
                    return model.children.some(item => { return this.isContains(this.search, item.name) })
                })
            } else {
                if (this.model.root == this.root) {
                    this.open = this.findByCriteria(this.model, model => {
                        return model.children.some(item => { return item.value == this.value })
                    }) || this.open
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tree/tree-item.js